var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"linkButton",class:_vm.linkButtonStyleClass,attrs:{"href":_vm.href,"target":"_blank","role":"button"}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }